export const FormatsData: import('../../../sim/dex-species').ModdedSpeciesFormatsDataTable = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	venusaurmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	venusaurgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	charizardmegax: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	charizardmegay: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	charizardgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		tier: "NUBL",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	blastoisemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	blastoisegmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	butterfreegmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	weedle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	kakuna: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	beedrill: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	beedrillmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	pidgey: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	pidgeotto: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	pidgeot: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pidgeotmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	rattata: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	rattataalola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	raticate: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	raticatealola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	raticatealolatotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	spearow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	fearow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	ekans: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	arbok: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pichu: {
		tier: "LC",
	},
	pichuspikyeared: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachu: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachucosplay: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachurockstar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachubelle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachupopstar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachuphd: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachulibre: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachuoriginal: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachuhoenn: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachusinnoh: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachuunova: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachukalos: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachualola: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachupartner: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachustarter: {
		isNonstandard: "LGPE",
		tier: "Illegal",
	},
	pikachugmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	pikachuworld: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	raichu: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	raichualola: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sandshrew: {
		tier: "LC",
	},
	sandshrewalola: {
		tier: "NUBL",
		doublesTier: "LC",
		natDexTier: "LC",
	},
	sandslash: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sandslashalola: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		tier: "ZU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	clefable: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	vulpix: {
		tier: "LC",
	},
	vulpixalola: {
		tier: "NFE",
		natDexTier: "LC",
	},
	ninetales: {
		tier: "ZU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	ninetalesalola: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "NFE",
	},
	crobat: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	bellossom: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	paras: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	parasect: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	venonat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	venomoth: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	diglett: {
		tier: "LC",
	},
	diglettalola: {
		tier: "LC",
	},
	dugtrio: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dugtrioalola: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	meowth: {
		tier: "LC",
	},
	meowthalola: {
		tier: "LC",
	},
	meowthgalar: {
		tier: "LC",
	},
	meowthgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	persian: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	persianalola: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	perrserker: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mankey: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	primeape: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	growlithe: {
		tier: "LC",
	},
	growlithehisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	arcanine: {
		tier: "NU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	arcaninehisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NFE",
	},
	poliwrath: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	politoed: {
		tier: "ZU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "NFE",
	},
	alakazam: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	alakazammega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "NFE",
	},
	machamp: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	machampgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	bellsprout: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	weepinbell: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	victreebel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	tentacool: {
		tier: "LC",
	},
	tentacruel: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	geodude: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	geodudealola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	graveler: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	graveleralola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	golem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	golemalola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	ponyta: {
		tier: "LC",
	},
	ponytagalar: {
		tier: "LC",
	},
	rapidash: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rapidashgalar: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	slowpoke: {
		tier: "LC",
	},
	slowpokegalar: {
		tier: "LC",
	},
	slowbro: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	slowbromega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	slowbrogalar: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	slowking: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	slowkinggalar: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "PU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	magnezone: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	farfetchd: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	farfetchdgalar: {
		tier: "LC",
	},
	sirfetchd: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	doduo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	dodrio: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	seel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	dewgong: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	grimer: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	grimeralola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	muk: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mukalola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gastly: {
		tier: "NFE",
		natDexTier: "LC",
	},
	haunter: {
		tier: "ZUBL",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	gengar: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	gengarmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	gengargmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	onix: {
		tier: "LC",
	},
	steelix: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	steelixmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	drowzee: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	hypno: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	kinglergmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	voltorb: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	voltorbhisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	electrode: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	electrodehisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	exeggcute: {
		tier: "LC",
	},
	exeggutor: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	exeggutoralola: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	marowakalola: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	marowakalolatotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	hitmonchan: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	hitmontop: {
		tier: "NU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	lickitung: {
		tier: "LC",
	},
	lickilicky: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	weezinggalar: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		tier: "ZU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	rhyperior: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	happiny: {
		tier: "LC",
	},
	chansey: {
		tier: "UU",
		doublesTier: "NFE",
		natDexTier: "OU",
	},
	blissey: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	tangela: {
		tier: "NFE",
		natDexTier: "LC",
	},
	tangrowth: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	kangaskhan: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	kangaskhanmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NFE",
	},
	kingdra: {
		tier: "PUBL",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mimejr: {
		tier: "LC",
	},
	mrmime: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mrmimegalar: {
		tier: "NFE",
	},
	mrrime: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	scyther: {
		tier: "PUBL",
		doublesTier: "NFE",
		natDexTier: "LC",
	},
	scizor: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "UU",
	},
	scizormega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	smoochum: {
		tier: "LC",
	},
	jynx: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	elekid: {
		tier: "LC",
	},
	electabuzz: {
		tier: "NFE",
	},
	electivire: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	magby: {
		tier: "NFE",
	},
	magmar: {
		tier: "NFE",
	},
	magmortar: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pinsir: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pinsirmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	tauros: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	gyaradosmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	lapras: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	laprasgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	ditto: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	eevee: {
		tier: "LC",
	},
	eeveestarter: {
		isNonstandard: "LGPE",
		tier: "Illegal",
	},
	eeveegmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	vaporeon: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	jolteon: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	flareon: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	espeon: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	umbreon: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	leafeon: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	glaceon: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sylveon: {
		tier: "NU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	porygon: {
		tier: "LC",
	},
	porygon2: {
		tier: "RU",
		doublesTier: "DOU",
		natDexTier: "NFE",
	},
	porygonz: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	aerodactyl: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	aerodactylmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	munchlax: {
		tier: "LC",
	},
	snorlax: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	snorlaxgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	articuno: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	articunogalar: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	zapdos: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	zapdosgalar: {
		tier: "UUBL",
		doublesTier: "DUU",
		natDexTier: "UUBL",
	},
	moltres: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	moltresgalar: {
		tier: "UUBL",
		doublesTier: "DUU",
		natDexTier: "UUBL",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NFE",
	},
	dragonite: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	mewtwo: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	mewtwomegax: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	mewtwomegay: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	mew: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "UUBL",
	},
	chikorita: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	bayleef: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	meganium: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cyndaquil: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	quilava: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	typhlosion: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	typhlosionhisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	totodile: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	croconaw: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	feraligatr: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sentret: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	furret: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	hoothoot: {
		tier: "LC",
	},
	noctowl: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	ledyba: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ledian: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	spinarak: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ariados: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	chinchou: {
		tier: "LC",
	},
	lanturn: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	togepi: {
		tier: "LC",
	},
	togetic: {
		tier: "NFE",
	},
	togekiss: {
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	natu: {
		tier: "LC",
	},
	xatu: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mareep: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	flaaffy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	ampharos: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	ampharosmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	azurill: {
		tier: "LC",
	},
	marill: {
		tier: "NFE",
	},
	azumarill: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	bonsly: {
		tier: "LC",
	},
	sudowoodo: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	hoppip: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	skiploom: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	jumpluff: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	aipom: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ambipom: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sunkern: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	sunflora: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	yanma: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	yanmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wooper: {
		tier: "LC",
	},
	quagsire: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	murkrow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	honchkrow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	misdreavus: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	mismagius: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	unown: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wynaut: {
		tier: "LC",
	},
	wobbuffet: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	girafarig: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pineco: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	forretress: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	dunsparce: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gligar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	gliscor: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	snubbull: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	granbull: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	qwilfish: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	qwilfishhisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	shuckle: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	heracross: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	heracrossmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	sneasel: {
		tier: "ZUBL",
		doublesTier: "NFE",
		natDexTier: "LC",
	},
	sneaselhisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	weavile: {
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "OU",
	},
	teddiursa: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ursaring: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	slugma: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	magcargo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		tier: "ZU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	mamoswine: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	corsola: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	corsolagalar: {
		tier: "NFE",
		natDexTier: "LC",
	},
	cursola: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	remoraid: {
		tier: "LC",
	},
	octillery: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	delibird: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mantyke: {
		tier: "LC",
	},
	mantine: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	skarmory: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	houndour: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	houndoom: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	houndoommega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	phanpy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	donphan: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	stantler: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	smeargle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	miltank: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	raikou: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	entei: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	suicune: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NFE",
	},
	tyranitar: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	tyranitarmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "(OU)",
	},
	lugia: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	hooh: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	celebi: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	treecko: {
		tier: "LC",
	},
	grovyle: {
		tier: "NFE",
	},
	sceptile: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sceptilemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	torchic: {
		tier: "LC",
	},
	combusken: {
		tier: "NFE",
	},
	blaziken: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	blazikenmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	mudkip: {
		tier: "LC",
	},
	marshtomp: {
		tier: "NFE",
	},
	swampert: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	swampertmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	poochyena: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	mightyena: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	zigzagoon: {
		tier: "NFE",
		natDexTier: "LC",
	},
	zigzagoongalar: {
		tier: "LC",
	},
	linoone: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	linoonegalar: {
		tier: "NFE",
	},
	obstagoon: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	wurmple: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	silcoon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	beautifly: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cascoon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	dustox: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	lotad: {
		tier: "LC",
	},
	lombre: {
		tier: "NFE",
	},
	ludicolo: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	seedot: {
		tier: "LC",
	},
	nuzleaf: {
		tier: "NFE",
	},
	shiftry: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	taillow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	swellow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wingull: {
		tier: "LC",
	},
	pelipper: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	ralts: {
		tier: "LC",
	},
	kirlia: {
		tier: "NFE",
	},
	gardevoir: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gardevoirmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	gallade: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gallademega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	surskit: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	masquerain: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	shroomish: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	breloom: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	slakoth: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	vigoroth: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	slaking: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	nincada: {
		tier: "LC",
	},
	ninjask: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	shedinja: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	whismur: {
		tier: "LC",
	},
	loudred: {
		tier: "NFE",
	},
	exploud: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	makuhita: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	hariyama: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	nosepass: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	probopass: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	skitty: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	delcatty: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sableye: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sableyemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	mawile: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mawilemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	aron: {
		tier: "LC",
	},
	lairon: {
		tier: "NFE",
	},
	aggron: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	aggronmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	meditite: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	medicham: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	medichammega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	electrike: {
		tier: "LC",
	},
	manectric: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	manectricmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	plusle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	minun: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	volbeat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	illumise: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	budew: {
		tier: "LC",
	},
	roselia: {
		tier: "NFE",
	},
	roserade: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gulpin: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	swalot: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	carvanha: {
		tier: "LC",
	},
	sharpedo: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sharpedomega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	wailmer: {
		tier: "LC",
	},
	wailord: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	numel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	camerupt: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cameruptmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	torkoal: {
		tier: "UU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	spoink: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	grumpig: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	spinda: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	trapinch: {
		tier: "LC",
	},
	vibrava: {
		tier: "NFE",
	},
	flygon: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cacnea: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	cacturne: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	swablu: {
		tier: "LC",
	},
	altaria: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	altariamega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	zangoose: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	seviper: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	lunatone: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	solrock: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	barboach: {
		tier: "LC",
	},
	whiscash: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	corphish: {
		tier: "LC",
	},
	crawdaunt: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	baltoy: {
		tier: "LC",
	},
	claydol: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lileep: {
		tier: "LC",
	},
	cradily: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	anorith: {
		tier: "LC",
	},
	armaldo: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	feebas: {
		tier: "LC",
	},
	milotic: {
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	castform: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	castformsunny: {
		isNonstandard: "Past",
	},
	castformrainy: {
		isNonstandard: "Past",
	},
	castformsnowy: {
		isNonstandard: "Past",
	},
	kecleon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	shuppet: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	banette: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	banettemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	duskull: {
		tier: "LC",
	},
	dusclops: {
		tier: "NFE",
	},
	dusknoir: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	tropius: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	chingling: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	chimecho: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	absol: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	absolmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	snorunt: {
		tier: "LC",
	},
	glalie: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	glaliemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	froslass: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	spheal: {
		tier: "LC",
	},
	sealeo: {
		tier: "NFE",
	},
	walrein: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	clamperl: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	huntail: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	gorebyss: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	relicanth: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	luvdisc: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	bagon: {
		tier: "LC",
	},
	shelgon: {
		tier: "NFE",
	},
	salamence: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	salamencemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	beldum: {
		tier: "LC",
	},
	metang: {
		tier: "NFE",
	},
	metagross: {
		tier: "RU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	metagrossmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	regirock: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	regice: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	registeel: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	latias: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	latiasmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	latios: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	latiosmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	kyogre: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	kyogreprimal: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	groudon: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	groudonprimal: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	rayquaza: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	rayquazamega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	jirachi: {
		tier: "UU",
		doublesTier: "DUber",
		natDexTier: "UUBL",
	},
	deoxys: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	deoxysattack: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	deoxysdefense: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	deoxysspeed: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	turtwig: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	grotle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	torterra: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	chimchar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	monferno: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	infernape: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	piplup: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	prinplup: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	empoleon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	starly: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	staravia: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	staraptor: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	bidoof: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	bibarel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	kricketot: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	kricketune: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	shinx: {
		tier: "LC",
	},
	luxio: {
		tier: "NFE",
	},
	luxray: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cranidos: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	rampardos: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	shieldon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	bastiodon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	burmy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	wormadam: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wormadamsandy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wormadamtrash: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mothim: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	combee: {
		tier: "LC",
	},
	vespiquen: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pachirisu: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	buizel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	floatzel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cherubi: {
		tier: "NFE",
		natDexTier: "LC",
	},
	cherrim: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cherrimsunshine: {
	},
	shellos: {
		tier: "LC",
	},
	gastrodon: {
		tier: "NU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	drifloon: {
		tier: "NFE",
		natDexTier: "LC",
	},
	drifblim: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	buneary: {
		tier: "LC",
	},
	lopunny: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lopunnymega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	glameow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	purugly: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	stunky: {
		tier: "LC",
	},
	skuntank: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	bronzor: {
		tier: "LC",
	},
	bronzong: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	chatot: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	spiritomb: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gible: {
		tier: "LC",
	},
	gabite: {
		tier: "NFE",
	},
	garchomp: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	garchompmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "(OU)",
	},
	riolu: {
		tier: "LC",
	},
	lucario: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lucariomega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	hippopotas: {
		tier: "LC",
	},
	hippowdon: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	skorupi: {
		tier: "LC",
	},
	drapion: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	croagunk: {
		tier: "LC",
	},
	toxicroak: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	carnivine: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	finneon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	lumineon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	snover: {
		tier: "LC",
	},
	abomasnow: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	abomasnowmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	rotom: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rotomheat: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	rotomwash: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	rotomfrost: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rotomfan: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rotommow: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	uxie: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mesprit: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	azelf: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dialga: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	dialgaorigin: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	palkia: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	palkiaorigin: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	heatran: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	regigigas: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	giratina: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	giratinaorigin: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	cresselia: {
		tier: "NUBL",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	phione: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	manaphy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	darkrai: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	shaymin: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	shayminsky: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	arceus: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	arceusbug: {
		isNonstandard: "Past",
	},
	arceusdark: {
		isNonstandard: "Past",
	},
	arceusdragon: {
		isNonstandard: "Past",
	},
	arceuselectric: {
		isNonstandard: "Past",
	},
	arceusfairy: {
		isNonstandard: "Past",
	},
	arceusfighting: {
		isNonstandard: "Past",
	},
	arceusfire: {
		isNonstandard: "Past",
	},
	arceusflying: {
		isNonstandard: "Past",
	},
	arceusghost: {
		isNonstandard: "Past",
	},
	arceusgrass: {
		isNonstandard: "Past",
	},
	arceusground: {
		isNonstandard: "Past",
	},
	arceusice: {
		isNonstandard: "Past",
	},
	arceuspoison: {
		isNonstandard: "Past",
	},
	arceuspsychic: {
		isNonstandard: "Past",
	},
	arceusrock: {
		isNonstandard: "Past",
	},
	arceussteel: {
		isNonstandard: "Past",
	},
	arceuswater: {
		isNonstandard: "Past",
	},
	victini: {
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "OU",
	},
	snivy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	servine: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	serperior: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	tepig: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	pignite: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	emboar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	oshawott: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	dewott: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	samurott: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	samurotthisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	patrat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	watchog: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	lillipup: {
		tier: "LC",
	},
	herdier: {
		tier: "NFE",
	},
	stoutland: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	purrloin: {
		tier: "LC",
	},
	liepard: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pansage: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	simisage: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pansear: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	simisear: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	panpour: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	simipour: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	munna: {
		tier: "LC",
	},
	musharna: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pidove: {
		tier: "LC",
	},
	tranquill: {
		tier: "NFE",
	},
	unfezant: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	blitzle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	zebstrika: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	roggenrola: {
		tier: "LC",
	},
	boldore: {
		tier: "NFE",
	},
	gigalith: {
		tier: "PU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	woobat: {
		tier: "NFE",
		natDexTier: "LC",
	},
	swoobat: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	drilbur: {
		tier: "LC",
	},
	excadrill: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "OU",
	},
	audino: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	audinomega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	timburr: {
		tier: "LC",
	},
	gurdurr: {
		tier: "ZU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	conkeldurr: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	tympole: {
		tier: "LC",
	},
	palpitoad: {
		tier: "NFE",
	},
	seismitoad: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	throh: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sawk: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sewaddle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	swadloon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	leavanny: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	venipede: {
		tier: "LC",
	},
	whirlipede: {
		tier: "NFE",
	},
	scolipede: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	cottonee: {
		tier: "LC",
	},
	whimsicott: {
		tier: "PU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	petilil: {
		tier: "LC",
	},
	lilligant: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lilliganthisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	basculin: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	basculinbluestriped: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	basculinwhitestriped: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	sandile: {
		tier: "LC",
	},
	krokorok: {
		tier: "NFE",
	},
	krookodile: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "UU",
	},
	darumaka: {
		tier: "LC",
	},
	darumakagalar: {
		tier: "LC",
	},
	darmanitan: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	darmanitanzen: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	darmanitangalar: {
		tier: "Uber",
		doublesTier: "(DUU)",
		natDexTier: "Uber",
	},
	darmanitangalarzen: {
		tier: "Uber",
		doublesTier: "(DUU)",
		natDexTier: "Uber",
	},
	maractus: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dwebble: {
		tier: "LC",
	},
	crustle: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	scraggy: {
		tier: "NFE",
		natDexTier: "LC",
	},
	scrafty: {
		tier: "PUBL",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	sigilyph: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	yamask: {
		tier: "LC",
	},
	yamaskgalar: {
		tier: "LC",
	},
	cofagrigus: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	runerigus: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	tirtouga: {
		tier: "LC",
	},
	carracosta: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	archen: {
		tier: "LC",
	},
	archeops: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	trubbish: {
		tier: "LC",
	},
	garbodor: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	garbodorgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	zorua: {
		tier: "LC",
	},
	zoruahisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	zoroark: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	zoroarkhisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	minccino: {
		tier: "LC",
	},
	cinccino: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gothita: {
		tier: "NFE",
		natDexTier: "LC",
	},
	gothorita: {
		tier: "NFE",
	},
	gothitelle: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	solosis: {
		tier: "LC",
	},
	duosion: {
		tier: "NFE",
	},
	reuniclus: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	ducklett: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	swanna: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	vanillite: {
		tier: "LC",
	},
	vanillish: {
		tier: "NFE",
	},
	vanilluxe: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	deerling: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	sawsbuck: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	emolga: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	karrablast: {
		tier: "LC",
	},
	escavalier: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	foongus: {
		tier: "LC",
	},
	amoonguss: {
		tier: "UU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	frillish: {
		tier: "LC",
	},
	jellicent: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	alomomola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	joltik: {
		tier: "LC",
	},
	galvantula: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	ferroseed: {
		tier: "PU",
		doublesTier: "NFE",
		natDexTier: "LC",
	},
	ferrothorn: {
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "OU",
	},
	klink: {
		tier: "LC",
	},
	klang: {
		tier: "NFE",
	},
	klinklang: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	tynamo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	eelektrik: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	eelektross: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	elgyem: {
		tier: "LC",
	},
	beheeyem: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	litwick: {
		tier: "LC",
	},
	lampent: {
		tier: "NFE",
	},
	chandelure: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	axew: {
		tier: "LC",
	},
	fraxure: {
		tier: "NFE",
	},
	haxorus: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	cubchoo: {
		tier: "LC",
	},
	beartic: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cryogonal: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	shelmet: {
		tier: "LC",
	},
	accelgor: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	stunfisk: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	stunfiskgalar: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mienfoo: {
		tier: "LC",
	},
	mienshao: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	druddigon: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	golett: {
		tier: "LC",
	},
	golurk: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pawniard: {
		tier: "LC",
	},
	bisharp: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	bouffalant: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rufflet: {
		tier: "NFE",
		natDexTier: "LC",
	},
	braviary: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	braviaryhisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	vullaby: {
		tier: "LC",
	},
	mandibuzz: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	heatmor: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	durant: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	deino: {
		tier: "LC",
	},
	zweilous: {
		tier: "NFE",
	},
	hydreigon: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	larvesta: {
		tier: "LC",
	},
	volcarona: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	cobalion: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	terrakion: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	virizion: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	tornadus: {
		tier: "NUBL",
		doublesTier: "DUU",
		natDexTier: "RUBL",
	},
	tornadustherian: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "Uber",
	},
	thundurus: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	thundurustherian: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	reshiram: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	zekrom: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	landorus: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	landorustherian: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	kyurem: {
		tier: "Uber",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	kyuremblack: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	kyuremwhite: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	keldeo: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	keldeoresolute: {
	},
	meloetta: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	meloettapirouette: {
		isNonstandard: "Past",
	},
	genesect: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	genesectburn: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	genesectchill: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	genesectdouse: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	genesectshock: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	chespin: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	quilladin: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	chesnaught: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	fennekin: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	braixen: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	delphox: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	froakie: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	frogadier: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	greninja: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	greninjabond: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	greninjaash: {
		isNonstandard: "Past",
	},
	bunnelby: {
		tier: "LC",
	},
	diggersby: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	fletchling: {
		tier: "LC",
	},
	fletchinder: {
		tier: "NFE",
	},
	talonflame: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	scatterbug: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	spewpa: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	vivillon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	vivillonfancy: {
		isNonstandard: "Past",
	},
	vivillonpokeball: {
		isNonstandard: "Past",
	},
	litleo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	pyroar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	flabebe: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	floette: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	floetteeternal: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	florges: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	skiddo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	gogoat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pancham: {
		tier: "LC",
	},
	pangoro: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	furfrou: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	espurr: {
		tier: "LC",
	},
	meowstic: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	meowsticf: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	honedge: {
		tier: "LC",
	},
	doublade: {
		tier: "PU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	aegislash: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	aegislashblade: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	spritzee: {
		tier: "LC",
	},
	aromatisse: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	swirlix: {
		tier: "NFE",
		natDexTier: "LC",
	},
	slurpuff: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	inkay: {
		tier: "LC",
	},
	malamar: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	binacle: {
		tier: "LC",
	},
	barbaracle: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	skrelp: {
		tier: "LC",
	},
	dragalge: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	clauncher: {
		tier: "LC",
	},
	clawitzer: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	helioptile: {
		tier: "LC",
	},
	heliolisk: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	tyrunt: {
		tier: "LC",
	},
	tyrantrum: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	amaura: {
		tier: "LC",
	},
	aurorus: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	hawlucha: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	dedenne: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	carbink: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	goomy: {
		tier: "LC",
	},
	sliggoo: {
		tier: "NFE",
	},
	sliggoohisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	goodra: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	goodrahisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	klefki: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	phantump: {
		tier: "LC",
	},
	trevenant: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pumpkaboo: {
		tier: "LC",
	},
	pumpkaboosmall: {
		tier: "LC",
	},
	pumpkaboolarge: {
		tier: "LC",
	},
	pumpkaboosuper: {
		tier: "LC",
	},
	gourgeist: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gourgeistsmall: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gourgeistlarge: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gourgeistsuper: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	bergmite: {
		tier: "LC",
	},
	avalugg: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	avalugghisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	noibat: {
		tier: "LC",
	},
	noivern: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	xerneas: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	xerneasneutral: {
		isNonstandard: "Custom", // can't be used in battle
		tier: "Illegal",
	},
	yveltal: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	zygarde: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	zygarde10: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	zygardecomplete: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	diancie: {
		tier: "NU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	dianciemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	hoopa: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	hoopaunbound: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	volcanion: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	rowlet: {
		tier: "LC",
	},
	dartrix: {
		tier: "NFE",
	},
	decidueye: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	decidueyehisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	litten: {
		tier: "LC",
	},
	torracat: {
		tier: "NFE",
	},
	incineroar: {
		tier: "RU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	popplio: {
		tier: "LC",
	},
	brionne: {
		tier: "NFE",
	},
	primarina: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RUBL",
	},
	pikipek: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	trumbeak: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	toucannon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	yungoos: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	gumshoos: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	gumshoostotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	grubbin: {
		tier: "LC",
	},
	charjabug: {
		tier: "NFE",
	},
	vikavolt: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	vikavolttotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	crabrawler: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	crabominable: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	oricorio: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	oricoriopompom: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	oricoriopau: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	oricoriosensu: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cutiefly: {
		tier: "NFE",
		natDexTier: "LC",
	},
	ribombee: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	ribombeetotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	rockruff: {
		tier: "LC",
	},
	rockruffdusk: {
		tier: "LC",
	},
	lycanroc: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lycanrocmidnight: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lycanrocdusk: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	wishiwashi: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	wishiwashischool: {
	},
	mareanie: {
		tier: "LC",
	},
	toxapex: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	mudbray: {
		tier: "LC",
	},
	mudsdale: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dewpider: {
		tier: "LC",
	},
	araquanid: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	araquanidtotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	fomantis: {
		tier: "LC",
	},
	lurantis: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lurantistotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	morelull: {
		tier: "LC",
	},
	shiinotic: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	salandit: {
		tier: "LC",
	},
	salazzle: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	salazzletotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	stufful: {
		tier: "LC",
	},
	bewear: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	bounsweet: {
		tier: "LC",
	},
	steenee: {
		tier: "NFE",
	},
	tsareena: {
		tier: "NU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	comfey: {
		tier: "PU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	oranguru: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	passimian: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	wimpod: {
		tier: "LC",
	},
	golisopod: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sandygast: {
		tier: "LC",
	},
	palossand: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pyukumuku: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	typenull: {
		tier: "NFE",
	},
	silvally: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallybug: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallydark: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallydragon: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallyelectric: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallyfairy: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallyfighting: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallyfire: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallyflying: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallyghost: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallygrass: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallyground: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallyice: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallypoison: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallypsychic: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallyrock: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallysteel: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallywater: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	minior: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	miniormeteor: {
		isNonstandard: "Past",
	},
	komala: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	turtonator: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	togedemaru: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	togedemarutotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mimikyu: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mimikyutotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mimikyubustedtotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	bruxish: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	drampa: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dhelmise: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	jangmoo: {
		tier: "LC",
	},
	hakamoo: {
		tier: "NFE",
	},
	kommoo: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	kommoototem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	tapukoko: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	tapulele: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	tapubulu: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RUBL",
	},
	tapufini: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	cosmog: {
		tier: "LC",
	},
	cosmoem: {
		tier: "NFE",
	},
	solgaleo: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	lunala: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	nihilego: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	buzzwole: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	pheromosa: {
		tier: "Uber",
		doublesTier: "(DUU)",
		natDexTier: "Uber",
	},
	xurkitree: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	celesteela: {
		tier: "UU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	kartana: {
		tier: "OU",
		doublesTier: "DUber",
		natDexTier: "OU",
	},
	guzzlord: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	necrozma: {
		tier: "RUBL",
		doublesTier: "DOU",
		natDexTier: "RUBL",
	},
	necrozmaduskmane: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	necrozmadawnwings: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	necrozmaultra: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	magearna: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	magearnaoriginal: {
	},
	marshadow: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	poipole: {
		tier: "NFE",
	},
	naganadel: {
		tier: "Uber",
		doublesTier: "DUU",
		natDexTier: "Uber",
	},
	stakataka: {
		tier: "NU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	blacephalon: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	zeraora: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	meltan: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	melmetal: {
		tier: "OU",
		doublesTier: "DUber",
		natDexTier: "UUBL",
	},
	melmetalgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	grookey: {
		tier: "LC",
	},
	thwackey: {
		tier: "ZU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	rillaboom: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	rillaboomgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	scorbunny: {
		tier: "LC",
	},
	raboot: {
		tier: "NFE",
	},
	cinderace: {
		tier: "Uber",
		doublesTier: "DUU",
		natDexTier: "Uber",
	},
	cinderacegmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	sobble: {
		tier: "LC",
	},
	drizzile: {
		tier: "NFE",
	},
	inteleon: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	inteleongmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	skwovet: {
		tier: "LC",
	},
	greedent: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rookidee: {
		tier: "LC",
	},
	corvisquire: {
		tier: "NFE",
	},
	corviknight: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	corviknightgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	blipbug: {
		tier: "LC",
	},
	dottler: {
		tier: "NFE",
	},
	orbeetle: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	orbeetlegmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	nickit: {
		tier: "LC",
	},
	thievul: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gossifleur: {
		tier: "LC",
	},
	eldegoss: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	wooloo: {
		tier: "LC",
	},
	dubwool: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	chewtle: {
		tier: "LC",
	},
	drednaw: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	drednawgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	yamper: {
		tier: "LC",
	},
	boltund: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rolycoly: {
		tier: "LC",
	},
	carkol: {
		tier: "NFE",
	},
	coalossal: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	coalossalgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	applin: {
		tier: "LC",
	},
	flapple: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	flapplegmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	appletun: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	appletungmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	silicobra: {
		tier: "LC",
	},
	sandaconda: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sandacondagmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	cramorant: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cramorantgulping: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cramorantgorging: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	arrokuda: {
		tier: "LC",
	},
	barraskewda: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	toxel: {
		tier: "LC",
	},
	toxtricity: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	toxtricitylowkey: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	toxtricitygmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	toxtricitylowkeygmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	sizzlipede: {
		tier: "LC",
	},
	centiskorch: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	centiskorchgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	clobbopus: {
		tier: "LC",
	},
	grapploct: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sinistea: {
		tier: "LC",
	},
	sinisteaantique: {
		tier: "LC",
	},
	polteageist: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	hatenna: {
		tier: "LC",
	},
	hattrem: {
		tier: "NFE",
	},
	hatterene: {
		tier: "UU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	hatterenegmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	impidimp: {
		tier: "LC",
	},
	morgrem: {
		tier: "NFE",
	},
	grimmsnarl: {
		tier: "NU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	grimmsnarlgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	milcery: {
		tier: "LC",
	},
	alcremie: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	alcremiegmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	falinks: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pincurchin: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	snom: {
		tier: "LC",
	},
	frosmoth: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	stonjourner: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	eiscue: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	indeedee: {
		tier: "NUBL",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	indeedeef: {
		tier: "NUBL",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	morpeko: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	morpekohangry: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cufant: {
		tier: "LC",
	},
	copperajah: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	copperajahgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	dracozolt: {
		tier: "UUBL",
		doublesTier: "DUU",
		natDexTier: "RUBL",
	},
	arctozolt: {
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dracovish: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	arctovish: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	duraludon: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	duraludongmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	dreepy: {
		tier: "LC",
	},
	drakloak: {
		tier: "NFE",
	},
	dragapult: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	zacian: {
		tier: "AG",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	zaciancrowned: {
		tier: "AG",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	zamazenta: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	zamazentacrowned: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	eternatus: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	eternatuseternamax: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	kubfu: {
		tier: "NFE",
	},
	urshifu: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	urshifurapidstrike: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	urshifugmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	urshifurapidstrikegmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	zarude: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	zarudedada: {
	},
	regieleki: {
		tier: "UU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	regidrago: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	glastrier: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	spectrier: {
		tier: "Uber",
		doublesTier: "DUU",
		natDexTier: "Uber",
	},
	calyrex: {
		tier: "ZU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	calyrexice: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	calyrexshadow: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	wyrdeer: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	kleavor: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	ursaluna: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	basculegion: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	basculegionf: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	sneasler: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	overqwil: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	enamorus: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	enamorustherian: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	missingno: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	syclar: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	syclant: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	revenankh: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	embirch: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	flarelm: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	pyroak: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	breezi: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	fidgit: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	rebble: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	tactite: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	stratagem: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	privatyke: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	arghonaut: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	nohface: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	kitsunoh: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	monohm: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	duohm: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	cyclohm: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	dorsoil: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	colossoil: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	protowatt: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	krilowatt: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	voodoll: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	voodoom: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	scratchet: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	tomohawk: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	necturine: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	necturna: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	mollux: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	cupra: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	argalis: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	aurumoth: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	brattler: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	malaconda: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	cawdet: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	cawmodore: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	volkritter: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	volkraken: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	snugglow: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	plasmanta: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	floatoy: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	caimanoe: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	naviathan: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	crucibelle: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	crucibellemega: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	pluffle: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	kerfluffle: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	pajantom: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	mumbao: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	jumbao: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	fawnifer: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	electrelk: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	caribolt: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	smogecko: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	smoguana: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	smokomodo: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	swirlpool: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	coribalis: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	snaelstrom: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	justyke: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	equilibra: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	solotl: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	astrolotl: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	miasmite: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	miasmaw: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	chromera: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	venomicon: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	venomiconepilogue: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	saharaja: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	pokestarsmeargle: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarufo: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarufo2: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarbrycenman: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarmt: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarmt2: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestartransport: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestargiant: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestargiant2: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarhumanoid: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarmonster: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarf00: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarf002: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarspirit: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarblackdoor: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarwhitedoor: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarblackbelt: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestargiantpropo2: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarufopropu2: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
};
